import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "wrapEmail" }
const _hoisted_2 = /*#__PURE__*/_createVNode("label", { class: "wrapEmail__label" }, " Email ", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "sepline" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.emails, (email, index) => {
      return (_openBlock(), _createBlock("div", {
        class: "wrapEmail__elEmail",
        key: index
      }, [
        _createVNode("input", {
          type: "email",
          class: "wrapEmail__input",
          value: email,
          onInput: $event => (_ctx.setData(index, $event))
        }, null, 40, ["value", "onInput"]),
        _hoisted_2
      ]))
    }), 128 /* KEYED_FRAGMENT */)),
    _hoisted_3,
    _createVNode("div", {
      onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.addEmail(...args))),
      class: "wrapEmail__btn"
    }, "Добавить email для рассылки")
  ]))
}